import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { MaterialRequestListAction } from './material-request-list.actions';
import { MaterialService } from '../../service/material.service';

@Injectable()
export class MaterialRequestListEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private service: MaterialService
  ) {}

  loadMaterialRequestListListRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MaterialRequestListAction.requestList),
      tap((action) =>
        this.logger.debug('@Effect Material Request List Requested: ' + JSON.stringify(action.criteriaObj))
      ),
      switchMap((action) => {
        return this.service.getMaterialRequestList(action.criteriaObj).pipe(
          map((data: any) => MaterialRequestListAction.responseList({ data })),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
